import { render, staticRenderFns } from "./DrawerAccordion.vue?vue&type=template&id=acd5bf06&scoped=true&"
import script from "./DrawerAccordion.vue?vue&type=script&lang=js&"
export * from "./DrawerAccordion.vue?vue&type=script&lang=js&"
import style0 from "./DrawerAccordion.vue?vue&type=style&index=0&id=acd5bf06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd5bf06",
  null
  
)

export default component.exports